import { TChatOnboardingType } from '../../types/chatOnboarding';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EChatOnboardingActionTypes {
  SetUnavailable = 'chatOnboarding/setUnavailable',
}

export const setChatOnboardingUnavailable = actionGenerator<
  EChatOnboardingActionTypes.SetUnavailable,
  TChatOnboardingType
>(EChatOnboardingActionTypes.SetUnavailable);

export type TChatOnboardingActions = ReturnType<typeof setChatOnboardingUnavailable>;
